import * as React from 'react';
import axios from 'axios';
import Loader from '../common/Loader';
import AxiosConfig from '../../utilities/AxiosConfig';
import Select from 'react-select';
// Bootstrap
import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import BootstrapTable from 'react-bootstrap-table-next';
import Button from 'react-bootstrap/Button';
// Function Imports
import filterFactory, { selectFilter } from 'react-bootstrap-table2-filter';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory from 'react-bootstrap-table2-paginator';
// CSS Imports
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import ExpandedRow from './ExpandedRow';
import CustomCSVButton from '../table/CustomCSVButton';
import "./ConfigureUsers.css"

let { SearchBar, ClearSearchButton } = Search;


const emptyUser = {
    UserId: NaN,
    UserName: "",
    DisplayName: "",
    ProfitCenter: "",
    SupervisorId: NaN,
    ProfitCenterId: NaN,
    State: "",
    EmployeeNumber: ""
}

function formatter(column, colIndex, { sortElement, filterElement }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: "space-between", alignItems: "flex-end" }}>
            <div className="d-flex flex-row align-items-end">{column.text}</div>
            { filterElement}
            { sortElement}
        </div>
    );
}

const paginationOptions = {
    showTotal: true,
    sizePerPageList: [
        {
            text: '15', value: 15
        },
        {
            text: '25', value: 25
        },
        {
            text: '50', value: 50,
        },
        {
            text: "100", value: 100,
        }
    ],
}

class ConfigureUsers extends React.Component {

    inputClearable = false

    constructor(props) {
        super(props);
        this.state = {
            users: [],
            allUsers: [],
            loading: true,
            filtered: false,
            selectedUser: emptyUser,
            selectedUserRoles: "",
            roles: [],
            editingUser: false,
            errorOpen: false,
            errorMessage: "",
            selectableOptions: {},
            profitCenters: {},
            selectedRole: null,
        }
    }

    componentDidMount() {
        this.getUsersAndRoles();
        const self = this
        document.onkeyup = function (e) {
            e = e || window.event;
            self.listenInput()
        };
    }

    getUsersAndRoles = (filter) => {
        this.setState({ loading: true });
        const configValue = AxiosConfig.configValue();
        axios.get(process.env.REACT_APP_API_URL + "/api/user/*", configValue)
            .then(response => {
                //console.log(response, response.data);
                let pc = response.data.reference.profitCenters;
                this.setState({
                    users: response.data.users,
                    allUsers: response.data.users,
                    selectableOptions: this._createOptionsList(pc),
                    profitCenters: this._arrayToObject(pc)
                });
                if (filter) {
                    this.roleFilter(filter)
                }
            })
            .then(() => {
                axios.get(process.env.REACT_APP_API_URL + '/api/portal/role/*', configValue)
                    .then(res => {
                        let roles = res.data.sort((a, b) => a.RoleName.localeCompare(b.RoleName))
                        roles.unshift({ RoleName: "All Users" })
                        this.setState({ roles: roles });
                        this.state.errorOpen && this.setState({ errorOpen: false });
                    })
                    .catch(err => {
                        //console.log(err);
                        this.setState({ errorOpen: true, errorMessage: "Error Receiving Roles from API" })
                    })
            })
            .catch(error => {
                //console.log(error);
                this.setState({ errorOpen: true, errorMessage: "Error Receiving Users from API." });
                AxiosConfig.handleError(error);
            })
            .finally(() => this.setState({ loading: false }));
    }

    _createOptionsList = (array, valueKey = "id", labelKey = "text") => {
        let options = [];
        array.forEach(item => {
            options.push({ value: item[valueKey], label: item[labelKey] });
        });
        //console.log("Options final array", options);
        return options;
    }

    _arrayToObject = (array, keyField = "id") =>
        array.reduce((obj, item) => {
            obj[item[keyField]] = item
            return obj
        }, {});

    newProfitCenterCreation = (pc) => {
        let final = {};
        let index = 0;
        pc.forEach(item => {
            final[index] = item.text;
            index++;
        });
        //console.log("New Profit Center Creation", final);
        return final;
    }

    expandedRow = {
        renderer: row => {
            return (
                <ExpandedRow row={row} />
            )
        },
        parentClassName: 'border border-primary',
    }

    rowEvents = {
        onClick: (e, row) => {
            //console.log("clicked");
            e.preventDefault();
            this.setState({ selectedUser: row });
        }
    }

    headerFormatter = (column, colIndex, { filterElement }) => (
        <div className="d-flex flex-column flex-md-row justify-content-around">
            {column.text}
            {filterElement}
        </div>
    )

    roleFilter = (role) => {
        if (role !== "All Users") {
            const configValue = AxiosConfig.configValue();
            axios.get(process.env.REACT_APP_API_URL + '/api/user/roleholders/' + role, configValue)
                .then(res => {
                    let temp = []
                    for (let i = 0; i < this.state.allUsers.length; i++) {
                        for (let j = 0; j < res.data.length; j++) {
                            if (this.state.allUsers[i].UserId === res.data[j]) {
                                temp.push(this.state.allUsers[i])
                            }
                        }
                    }
                    this.setState({ users: temp, selectedRole: role })
                })
                .catch(err => {
                    //console.log(err);
                    this.setState({ errorOpen: true, errorMessage: "Error Receiving Roles from API" })
                })
        } else {
            this.setState({ users: this.state.allUsers, selectedRole: role })
        }
    }

    /*The original table that was used for this page (https://react-bootstrap-table.github.io/react-bootstrap-table2/docs/basic-search.html)
    supports a clear search button but it isn't customizable (as of right now).  On Kens request the search field which is also provided by 
    the bootstrap library needed to have the alternating buttons change between clear and filter. See the componentWillMount() method and the following
    two functions*/

    clearInput = () => {
        let clearSearchBtn = document.getElementsByClassName("HiddenClearRolesSearchBtn")//hidden in css file
        if (clearSearchBtn[0]) {
            clearSearchBtn[0].click()
            this.inputClearable = false
        }
    }

    listenInput = () => {
        let input = document.getElementById("search-bar-0")
        if (input && input.value !== "") {
            this.inputClearable = true
        } else {
            this.inputClearable = false
        }
    }

    render() {
        const {
            loading,
            users,
            errorOpen,
            errorMessage,
        } = this.state;


        return (
            <>
                <Container fluid >
                    <h4>Role Management</h4>
                    {
                        loading
                            ?
                            <div style={{ height: "calc(100vh - 48px)" }} className="w-100 d-flex justify-content-center align-items-center">
                                <Loader title="Loading Users..." />
                            </div>
                            :
                            <ToolkitProvider
                                keyField="UserId"
                                bootstrap4
                                data={users}
                                columns={[
                                    { dataField: "DisplayName", text: "Display Name", headerFormatter: formatter },
                                    { dataField: "UserName", text: "Username", headerFormatter: formatter },
                                    {
                                        dataField: "HomeProfitCenter",
                                        text: "Profit Center",
                                        filter: selectFilter({
                                            options: this.state.selectableOptions,
                                            style: {
                                                width: "180px",
                                                margin: 0,
                                            },
                                        }),
                                        formatter: (cell, row, rowIndex) => this.state.profitCenters[row.HomeProfitCenterId]?.text,
                                        headerFormatter: this.headerFormatter,
                                        filterValue: (cell, row) => this.state.profitCenters[row.HomeProfitCenterId]?.id,
                                        classes: () => {
                                            return 'overflow-hidden';
                                        }
                                    }
                                ]}
                                search
                                exportCSV
                                rowEvents={this.rowEvents}
                            >
                                {
                                    props => (
                                        <div>
                                            <div className="d-flex flex-row w-100 justify-content-between">
                                                <div className="RoleSearchBarWrapper">
                                                    {this.inputClearable && <div id="role-search-clear-btn" onClick={this.clearInput}>
                                                        <span className="material-icons">close</span>
                                                    </div>}
                                                    {!this.inputClearable && <div id="role-search-search-btn">
                                                        <span className="material-icons">filter_alt</span>
                                                    </div>}
                                                    <ClearSearchButton className={"HiddenClearRolesSearchBtn"} {...props.searchProps} />
                                                    <SearchBar {...props.searchProps} />
                                                    {this.state.roles.length > 0 && <div className="RoleFilterWrapper">
                                                        <p>Users With Role: </p>
                                                        <Select
                                                            id="role-filter-select-dropdown"
                                                            value={{ label: this.state.selectedRole || "Select a Role" }}
                                                            options={this.state.roles.map((s) => ({ value: s.RoleName, label: s.RoleName }))}
                                                            onChange={(item) => {
                                                                this.roleFilter(item.value)
                                                            }}
                                                        />
                                                    </div>}
                                                </div>
                                                <CustomCSVButton {...props.csvProps} />
                                            </div>
                                            <BootstrapTable
                                                {...props.baseProps}
                                                expandRow={this.expandedRow}
                                                filter={filterFactory()}
                                                pagination={paginationFactory(paginationOptions)}
                                                hover={true}
                                                condensed={true}
                                                noDataIndication={() => <h5 className="p-2">No Users Found...</h5>}
                                            />
                                        </div>
                                    )
                                }
                            </ToolkitProvider>
                    }
                </Container>

                {/* Error Modal */}
                <Modal show={errorOpen} className="z-100">
                    <Modal.Header>
                        <Modal.Title className="d-flex flex-row w-100 justify-content-between align-items-center">
                            <i className="material-icons text-danger">error</i>
                        ERROR
                        <i className="material-icons text-danger">error</i>
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body className="d-flex justify-content-center align-items-center">
                        {errorMessage}
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ errorOpen: false })}>
                            Cancel
                    </Button>
                        <Button disabled={loading} variant="primary" onClick={() => this.getUsersAndRoles()}>
                            Try Again
                    </Button>
                    </Modal.Footer>
                </Modal>

            </>
        );
    }
}

export default ConfigureUsers;